import React from "react";
import { FormattedMessage } from "react-intl";
import { connect, useSelector } from "react-redux";

import LoadingIndicatorVisual from "../components/LoadingIndicatorVisual";
import { getDemValue } from "../state/selectedPoint";

import CollapsableSidebarStyles from "./CollapsableSidebar.module.css";
import RightMenuHeader from "./RightMenuHeader";

const NoData: React.FC = () => {
  const demValue = useSelector(getDemValue);

  const loading = demValue === null;
  const noData = demValue === -9999;

  return (
    <div
      className={`${CollapsableSidebarStyles.LeftMenu} ${CollapsableSidebarStyles.LeftMenuPadChildDivs}`}
    >
      <RightMenuHeader
        titleElement={
          <FormattedMessage id="selectedPointInspector.headerTitle" defaultMessage="Point" />
        }
        parent={"POINT"}
      />

      {loading ? (
        <LoadingIndicatorVisual width="50px" height="50px" />
      ) : noData ? (
        <div>The point you clicked is outside the Rana model domain. No information available.</div>
      ) : null}
    </div>
  );
};

export default connect(null, {})(NoData);
